export default __webpack_public_path__ + "static/media/home-finance-industries-img-01.d6cbc27d.jpg";